import { Dish, LegalEntity, Order } from '../../apiTypes';
import { updateDoc } from '../../utils/api';
import { BillCalc } from '../../utils/getBillCalc';
import { Map } from '../../utils/map';
import { PrroItem, getPrroDiscounts, getPrroItems } from '../../utils/prro';

type Props = {
  cafeSlug: string;
  order: DbDocument<Order>;
  billCalc: BillCalc;
  method: 'cash' | 'card';
  dishesMap: Map<DbDocument<Dish>>;
  legalEntity: DbDocument<LegalEntity>;
  defaultLegalEntityId?: string;
  service: number;
  discount: number;
};

export const fiscalize = async ({
  order,
  billCalc,
  cafeSlug,
  method,
  dishesMap,
  legalEntity,
  defaultLegalEntityId,
  discount,
  service,
}: Props) => {
  const orderItems = Object.values(order.items).filter(
    (i) => (i.legalEntityId || defaultLegalEntityId) === legalEntity.id
  );

  if (legalEntity?.prroCheckBox.key && dishesMap) {
    const prroItems: PrroItem[] = getPrroItems(orderItems, dishesMap);
    const discounts = getPrroDiscounts(legalEntity.id, billCalc, discount, service);
    const payments = [
      method === 'card' ? { type: 'CARD', label: 'Картка', value: 0 } : { type: 'CASH', label: 'Готівка', value: 0 },
    ];

    const res = await fetch('https://api.checkbox.in.ua/api/v1/receipts/sell', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${legalEntity.prroCheckBox.cashierToken}`,
        'X-Client-Name': 'FireMenu',
        'X-Client-Version': 'v0.1.1',
      },
      body: JSON.stringify({
        goods: prroItems,
        payments,
        rounding: true,
        footer: null,
        discounts,
      }),
    });

    const resJson = await res.json();

    if (res.status !== 201) {
      return { error: resJson.message as string };
    }

    if (resJson.id) {
      await updateDoc<Order>(`cafes/${cafeSlug}/orders/${order?.id}`, {
        [`prroReceipts.${legalEntity.id}.id`]: resJson.id,
      });
    }
  }

  return { success: true };
};
